/* Sweet Reminders theme JS.
   Much smaller than the static build: Shopify now owns the cart, the prices and
   the variant data, so shopify-variants.js / sr-catalog.js are gone. */
(function () {
  'use strict';

  /* ---------- product page: option buttons drive the real variant ---------- */
  var form = document.getElementById('product-form');
  var sel  = document.getElementById('variant-select');
  if (form && sel) {
    var dataEl = document.getElementById('variant-data');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];

    function chosen() {
      var out = [];
      document.querySelectorAll('.metals').forEach(function (row, i) {
        var on = row.querySelector('[aria-checked="true"]');
        out[i] = on ? on.getAttribute('data-val') : null;
      });
      return out;
    }

    function sync() {
      var want = chosen();
      var match = variants.filter(function (v) {
        return want.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
      if (!match) return;
      sel.value = match.id;
      var price = document.querySelector('.pprice');
      if (price && window.Shopify) price.textContent = formatMoney(match.price);
      var btn = document.getElementById('add'), lbl = document.getElementById('addlbl');
      if (btn) {
        btn.disabled = !match.available;
        if (lbl) lbl.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
      /* keep the URL shareable */
      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', match.id);
        history.replaceState({}, '', u);
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    document.querySelectorAll('.metal').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.metals');
        row.querySelectorAll('.metal').forEach(function (o) {
          o.setAttribute('aria-checked', 'false');
          o.setAttribute('aria-pressed', 'false');
        });
        b.setAttribute('aria-checked', 'true');
        b.setAttribute('aria-pressed', 'true');
        sync();
      });
    });

    /* gallery thumbs */
    document.querySelectorAll('.thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-i');
        document.querySelectorAll('.track img').forEach(function (img, n) {
          img.classList.toggle('on', n === i);
        });
        document.querySelectorAll('.thumb').forEach(function (o) { o.classList.remove('on'); });
        t.classList.add('on');
      });
    });
  }

  /* ---------- quick add from any grid card ---------- */
  document.addEventListener('click', function (e) {
    var qa = e.target.closest && e.target.closest('.qa');
    if (!qa) return;
    var card = qa.closest('a.card');
    var href = card ? card.getAttribute('href') || '' : '';
    /* sold out: let the tap fall through to the product page, which says so */
    if (card && card.classList.contains('soldout')) return;
    var id = qa.getAttribute('data-id');
    /* "View reminder" style buttons and cards with no variant id just open the product */
    if (!id && !/\/products\//.test(href)) return;
    if (!id && !/^Add to bag/.test(qa.textContent.trim())) return;
    e.preventDefault(); e.stopPropagation();
    var old = qa.textContent;
    qa.textContent = 'Adding…';
    (id ? Promise.resolve(id) : firstAvailable(href))
      .then(function (vid) {
        if (!vid) { var x = new Error('Sold out'); x.soldOut = true; throw x; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
        });
      })
      .then(function (r) {
        if (r.ok) return r.json();
        return r.json().then(function (j) { var x = new Error(j.description || 'Try again'); x.soldOut = r.status === 422; throw x; });
      })
      .then(function () { qa.innerHTML = 'Added <svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="width:1em;height:1em;vertical-align:-.12em"><path d="M4.5 12.6 9.5 17.5 19.5 6.5"/></svg>'; refreshCount(); })
      .catch(function (err) { qa.textContent = (err && err.soldOut) ? 'Sold out' : 'Try again'; })
      .then(function () { setTimeout(function () { qa.textContent = old; }, 1600); });
  }, true);

  /* first finish of a product that can still be bought, or null */
  function firstAvailable(href) {
    var h = String(href).split('?')[0].replace(/^.*\/products\//, '').replace(/\/$/, '');
    return fetch('/products/' + h + '.js')
      .then(function (r) { if (!r.ok) throw new Error('no product'); return r.json(); })
      .then(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        return v ? v.id : null;
      });
  }

  function refreshCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      document.querySelectorAll('a.cart b').forEach(function (b) { b.textContent = c.item_count; });
    }).catch(function () {});
  }

  /* ---------- wishlist (per browser; Shopify has no native wishlist) ---------- */
  var WKEY = 'sr-wish';
  function wish() {
    try { var v = JSON.parse(localStorage.getItem(WKEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function saveWish(l) {
    try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {}
    paintWish();
    /* the wishlist page redraws its grid when a heart there is tapped off */
    if (window.SRwishRender) window.SRwishRender();
  }
  /* which product a heart belongs to: its own data-handle, else the product
     link of the card it sits in (home + gift-quiz cards carry no data-handle) */
  function heartHandle(h) {
    var k = h.getAttribute('data-handle');
    if (k) return k;
    var a = h.closest('a[href*="/products/"]');
    return a ? a.getAttribute('href').split(/[?#]/)[0].replace(/^.*\/products\//, '').replace(/\/$/, '') : null;
  }
  function paintWish() {
    var l = wish();
    document.querySelectorAll('.heart').forEach(function (h) {
      var on = l.indexOf(heartHandle(h)) > -1;
      h.setAttribute('aria-pressed', on ? 'true' : 'false');
      h.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
      var t = h.querySelector('.wlt');
      if (t) t.textContent = on ? 'Saved' : 'Save';
    });
    document.querySelectorAll('a[href$="/pages/wishlist"] b, a[aria-label="Wishlist"] b').forEach(function (b) {
      b.textContent = l.length; b.style.display = l.length ? '' : 'none';
    });
  }
  document.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('.heart');
    if (!h) return;
    e.preventDefault(); e.stopPropagation();
    var handle = heartHandle(h);
    if (!handle) return;
    var l = wish(), i = l.indexOf(handle);
    if (i > -1) l.splice(i, 1); else l.push(handle);
    saveWish(l);
  }, true);


  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paintWish);
  else paintWish();
})();


/* ---------- site chrome: burger, mega-menu rails, hover-open ---------- */

(function(){var b=document.getElementById("burger"),n=document.getElementById("mnav"),
  o=document.getElementById("mnavOvl"),x=document.getElementById("mnavX");
 if(!b||!n)return;
 function open_(){n.classList.add("on");o.classList.add("on");b.setAttribute("aria-expanded","true");
   n.setAttribute("aria-hidden","false");b.setAttribute("aria-label","Close menu");document.body.style.overflow="hidden";}
 function close_(){n.classList.remove("on");o.classList.remove("on");b.setAttribute("aria-expanded","false");
   n.setAttribute("aria-hidden","true");b.setAttribute("aria-label","Open menu");document.body.style.overflow="";}
 b.addEventListener("click",function(){n.classList.contains("on")?close_():open_();});
 x.addEventListener("click",close_); o.addEventListener("click",close_);
 document.addEventListener("keydown",function(e){if(e.key==="Escape")close_();});
 window.addEventListener("resize",function(){if(window.innerWidth>1080)close_();});
})();


(function(){var menu=document.querySelector(".menu");if(!menu)return;
 var rails=menu.querySelectorAll(".mr"),panels=menu.querySelectorAll(".mp");
 function show(k){
  [].forEach.call(rails,function(r){r.classList.toggle("on",r.getAttribute("data-p")===k);});
  [].forEach.call(panels,function(p){p.classList.toggle("on",p.getAttribute("data-p")===k);});
 }
 [].forEach.call(rails,function(r){
  var k=r.getAttribute("data-p");
  r.addEventListener("mouseenter",function(){show(k);});
  r.addEventListener("focus",function(){show(k);});
 });
 var host=menu.closest(".hasmenu");
 if(host)host.addEventListener("mouseleave",function(){show("sets");});
})();


/* open on hover, close shortly after leaving - the grace period lets the pointer
   cross the gap diagonally without the panel snapping shut */
(function(){var li=document.querySelector(".hasmenu");if(!li)return;var t;
 function open_(){clearTimeout(t);li.classList.add("open");}
 function close_(){clearTimeout(t);t=setTimeout(function(){li.classList.remove("open");},170);}
 li.addEventListener("mouseenter",open_);
 li.addEventListener("mouseleave",close_);
 li.addEventListener("focusin",open_);
 li.addEventListener("focusout",function(e){if(!li.contains(e.relatedTarget))close_();});
 /* click/tap opens it too, so it never depends on hover alone */
 var trig=li.querySelector("a");
 if(trig){trig.setAttribute("aria-haspopup","true");trig.setAttribute("aria-expanded","false");
  trig.addEventListener("click",function(e){
    e.preventDefault();
    if(li.classList.contains("open")){clearTimeout(t);li.classList.remove("open");}
    else{open_();}
    trig.setAttribute("aria-expanded",String(li.classList.contains("open")));
  });}
 document.addEventListener("click",function(e){
   if(!li.contains(e.target)){clearTimeout(t);li.classList.remove("open");
     if(trig)trig.setAttribute("aria-expanded","false");}});
 document.addEventListener("keydown",function(e){
   if(e.key==="Escape"){clearTimeout(t);li.classList.remove("open");
     if(trig)trig.setAttribute("aria-expanded","false");}});
})();

/* ---------- compatibility shims for pages ported from the static build ----------
   sets.html and wishlist.html call SRadd()/SRwish(). In the static build those
   talked to a localStorage cart. Here they talk to the real Shopify cart. */
(function () {
  'use strict';

  /* items come through as {name, stone, img, u?} - the image filename carries
     the product handle (images/<handle>-0.jpg), same as the static build */
  function handleOf(it) {
    if (it.u) return String(it.u).replace(/\.html$/, '');
    if (it.handle) return it.handle;
    /* fall back to the image filename. Liquid renders asset_url as a CDN path
       with a ?v=... cache key, so strip the query before matching. */
    var f = String(it.img || '').split('?')[0].split('#')[0].replace(/^.*\//, '');
    return f.replace(/-\d+\.(jpg|jpeg|png|webp)$/i, '').replace(/\.(jpg|jpeg|png|webp)$/i, '');
  }

  function firstVariantId(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('no product'); return r.json(); })
      .then(function (p) {
        /* never fall back to a sold-out finish - Shopify would refuse it anyway */
        var v = (p.variants || []).filter(function (x) { return x.available; })[0];
        return v ? v.id : null;
      });
  }

  window.SRadd = function (items, open) {
    var list = (items || []).map(handleOf).filter(Boolean);
    if (!list.length) return Promise.resolve();
    return Promise.all(list.map(firstVariantId))
      .then(function (ids) {
        var lines = ids.filter(Boolean).map(function (id) { return { id: id, quantity: 1 }; });
        if (!lines.length) return;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: lines })
        });
      })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r && r.json(); })
      .then(function (c) {
        if (c) document.querySelectorAll('a.cart b').forEach(function (b) { b.textContent = c.item_count; });
        if (open !== false) window.location.href = '/cart';
      })
      .catch(function () {});
  };

  /* wishlist API the ported wishlist page expects */
  var WKEY = 'sr-wish';
  function read() {
    try { var v = JSON.parse(localStorage.getItem(WKEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(l) {
    try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('sr:wishchange', { detail: { list: l } }));
    if (window.SRwishRender) window.SRwishRender();
  }
  window.SRhandle = function (u) {
    return String(u || '').split(/[?#]/)[0].replace(/^.*\//, '').replace(/\.html$/i, '');
  };
  window.SRwish = {
    all: read,
    has: function (h) { return read().indexOf(window.SRhandle(h)) > -1; },
    count: function () { return read().length; },
    add: function (h) { var l = read(), k = window.SRhandle(h); if (l.indexOf(k) < 0) { l.push(k); write(l); } },
    remove: function (h) { var l = read(), i = l.indexOf(window.SRhandle(h)); if (i > -1) { l.splice(i, 1); write(l); } },
    toggle: function (h) { this.has(h) ? this.remove(h) : this.add(h); },
    clear: function () { write([]); }
  };
})();

/* ---------- fill data-cat on grid cards from the catalog ----------
   The collection page filters by recipient, but Shopify has no category
   field for these products, so it comes from sr-catalog.js by handle. */
(function () {
  function fill() {
    var cat = window.SR_CATALOG; if (!cat) return;
    document.querySelectorAll('.card[data-handle]').forEach(function (c) {
      if (c.getAttribute('data-cat')) return;
      var e = cat[c.getAttribute('data-handle')];
      if (e && e.c) c.setAttribute('data-cat', e.c);
      if (e && e.s && !c.getAttribute('data-stone')) c.setAttribute('data-stone', e.s.toLowerCase());
    });
    if (window.SRprettyCard) document.querySelectorAll('.card[data-handle]').forEach(function (c) {
      window.SRprettyCard(c, cat[c.getAttribute('data-handle')]);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill, true);
  else fill();
})();

/* ------------------------------------------------------------------
   Scroll behaviours, ported from the static build. The CSS for all
   three shipped with the theme but the JS never did, so 36 elements
   carrying .rv sat at opacity:0 - saved only by the reduced-motion
   failsafe, which meant the whole site rendered with no motion at all.
   ------------------------------------------------------------------ */
(function(){
  var E = Array.prototype.forEach;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reveal on scroll */
  var rv = document.querySelectorAll('.rv');
  if (rv.length){
    if (still || !('IntersectionObserver' in window)){
      E.call(rv, function(el){ el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        E.call(entries, function(e){
          if (e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, {threshold:.12, rootMargin:'0px 0px -40px 0px'});
      E.call(rv, function(el){ io.observe(el); });
      /* anything already on screen at load should not wait for a scroll */
      setTimeout(function(){
        E.call(document.querySelectorAll('.rv:not(.in)'), function(el){
          if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('in');
        });
      }, 60);
    }
  }

  /* header shrinks once you leave the top */
  var hd = document.querySelector('header');
  if (hd){
    var shrink = function(){ hd.classList.toggle('small', window.scrollY > 60); };
    window.addEventListener('scroll', shrink, {passive:true});
    shrink();
  }

  /* sticky sell bar: show past the hero, hide again near the footer */
  var bar = document.getElementById('stickybar'),
      hero = document.querySelector('.hero');
  if (bar && hero){
    var onScroll = function(){
      var past  = hero.getBoundingClientRect().bottom < 0,
          atEnd = (window.innerHeight + window.scrollY) > (document.body.offsetHeight - 260);
      bar.classList.toggle('up', past && !atEnd);
    };
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }
})();
